<script setup lang="ts">
withDefaults(defineProps<{ large?: boolean }>(), { large: false })
</script>

<template>
  <span
    class="brand"
    :class="{ 'brand--lg': large }"
  >
    <svg
      viewBox="0 0 40 40"
      aria-hidden="true"
      focusable="false"
    >
      <rect
        x="2"
        y="2"
        width="36"
        height="36"
        rx="10"
        fill="#9cecfe"
      />
      <circle
        cx="14"
        cy="16"
        r="4"
        fill="#222e48"
      />
      <circle
        cx="26"
        cy="16"
        r="4"
        fill="#222e48"
      />
      <path
        d="M9 23c2.5 4.5 6 7 11 7s8.5-2.5 11-7"
        fill="none"
        stroke="#222e48"
        stroke-width="3.5"
        stroke-linecap="round"
      />
      <circle
        cx="31"
        cy="8"
        r="4"
        fill="#ffba23"
      />
    </svg>
    <span><strong>Bar</strong> Bluff</span>
  </span>
</template>
